import { DurationUnit } from "components/DurationPicker/types";
import { format, parse } from "date-fns";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import {
    updateNewJobData,
    useGetJobByIdQuery,
    useGetJobPurposesQuery,
} from "slice/jobs";

export const useEditJob = () => {
    const { id: job_id } = useParams();

    const { pathname } = useLocation();

    const { agency } = useAppSelector((state) => state.user),
        { newJobData } = useAppSelector((state) => state.jobs),
        dispatch = useDispatch();

    const { data: jobPurposes } = useGetJobPurposesQuery({});
    const { data } = useGetJobByIdQuery(
        {
            agency_id: agency?.id ?? "",
            job_id: job_id ?? "",
        },
        {
            skip:
                !job_id ||
                !agency?.id ||
                !pathname.includes("edit") ||
                newJobData?.isEdit,
        }
    );
    useEffect(() => {
        if (data && jobPurposes) {
            const jobPurpose = jobPurposes.job_purposes?.find(
                (purpose) => purpose?.id === data?.job_purpose_id
            );
            const end_date = data?.end_date ?? "";
            const start_date = data?.start_date ?? "";
            dispatch(
                updateNewJobData({
                    isEdit: true,
                    id: job_id,
                    job_purpose: jobPurpose,
                    job_category: data.agency_category_id,
                    job_location: {
                        city: data.city,

                        country_name: data?.country_name,
                        application_from: data?.application_from,
                        application_from_country_names:
                            data?.application_from_country_names ?? [],
                    },
                    job_details: {
                        jobInfo: {
                            title: data?.title,
                            description: data?.description,
                            numberOfSeats: String(data?.no_of_seats),
                        },
                        dateInputs: {
                            start_date: start_date
                                ? format(
                                      parse(start_date, "dd-MM-yy", new Date()),
                                      "yyyy-MM-dd"
                                  )
                                : "",
                            end_date: end_date
                                ? format(
                                      parse(end_date, "dd-MM-yy", new Date()),
                                      "yyyy-MM-dd"
                                  )
                                : "",
                        },
                        durationInputs: {
                            duration: {
                                duration: data?.duration,
                                unit: data?.duration_unit as DurationUnit,
                            },
                            experience: {
                                duration: data?.experience,
                                unit:
                                    (data?.experience_unit as DurationUnit) ??
                                    "years",
                            },
                            minAge: {
                                duration: data?.applicant_min_age,
                                unit: "years",
                            },
                            maxAge: {
                                duration: data?.applicant_max_age,
                                unit: "years",
                            },
                        },
                        textInputs: {
                            bust: data.physical_details?.bust,
                            hair_length: data.physical_details?.hair_length,
                            hips: data.physical_details?.hips,
                            maxHeight: data.physical_details?.max_height,
                            maxWeight: data.physical_details?.max_weight,
                            minHeight: data.physical_details?.min_height,
                            minWeight: data.physical_details?.min_weight,
                            waist: data.physical_details?.waist,
                        },
                        dropdownInputs: {
                            ethnicity: data.physical_details?.ethnicity,
                            eye_color: data.physical_details?.eye_color,
                            gender: data?.gender,
                            hair_color: data.physical_details?.hair_color,
                            language_id: data?.language,
                            piercings: data.physical_details?.piercings,
                            qualification: data?.qualification,
                            tattoos: data.physical_details?.tattoos,
                        },
                    },
                    job_budget: {
                        payType: data.budget?.budget_type,
                        currency: data.budget?.currency,
                        durationCycle: data.budget?.duration_cycle,
                        additionalCompensation:
                            data.budget?.additional_compensation,
                        minAmount: String(data.budget?.min_amount || ""),
                        maxAmount: String(data.budget?.max_amount || ""),
                        status: String(data.status || ""),
                    },
                })
            );
        }
    }, [data, dispatch, jobPurposes, newJobData?.isEdit, job_id]);
};
